import React, { useState, useEffect } from 'react';
import Fade from '@material-ui/core/Fade';
import AddPolicyIntro from './components/liabilityPolicy/addPolicy/AddPolicyIntro';
import AddPolicyMain from './components/liabilityPolicy/addPolicy/AddPolicyMain';
import AddPolicySuccess from './components/liabilityPolicy/addPolicy/AddPolicySuccess';

const AddPolicy = () => {

  const [step, setStep] = useState(1);
  const [stepBack, setStepBack] = useState(null);
  const [showFade, setShowFade] = useState(true);

  const [plate, setPlate] = useState(null);
  const [policyId, setPolicyId] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const onBack = (toStep) => {
      toStep = stepBack ? stepBack : toStep;
      setShowFade(false);

      setTimeout(() => {
        setStep(toStep);
        setStepBack(null);
        setShowFade(true);
      }, 0);
  }

  const onForward = (toStep, backTo, plate, policyId) => {
      backTo ? setStepBack(backTo) : setStepBack(false);
      setShowFade(false);

      if(toStep === 3) {
        setPlate(plate);
        setPolicyId(policyId);
      }

      setTimeout(() => {
        setStep(toStep);
        setShowFade(true);
      }, 0);
      
  }

  const renderStepScreen = () => {
      switch (step) {
          case 1:
            return <AddPolicyIntro onForward={onForward} />;
          case 2:
            return <AddPolicyMain onBack={onBack} onForward={onForward} />;
          case 3:
            return <AddPolicySuccess plate={plate} policyId={policyId} />;
        
          default:
            return <div></div>;
      }
  }

  return (
      <div style={{position: 'realtive'}}>
          <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
            {renderStepScreen()}
          </Fade>
      </div>
  )
}

export default AddPolicy;